import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56585343"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_movies_grid = _resolveComponent("movies-grid")!
  const _component_movie_modal = _resolveComponent("movie-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_movies_grid, {
      "section-title": _ctx.genre?.name,
      movies: _ctx.movies,
      onOnOpenModal: _ctx.getMovieData
    }, null, 8, ["section-title", "movies", "onOnOpenModal"]),
    _createVNode(_component_movie_modal, {
      id: _ctx.movieId,
      "show-modal": _ctx.showModal,
      onCloseModal: _ctx.cleanModalData
    }, null, 8, ["id", "show-modal", "onCloseModal"])
  ]))
}